import { HierarchyBrowserEvents, useRefreshQueriesOn } from '@/lib/browser-events'
import { useSelectedEntityId } from '@/lib/use-selected-entity'

import { entityKeys } from './entity-queries'

export function EntityBrowserEvents(): React.ReactNode {
  const entityId = useSelectedEntityId()
  return entityId ? <EntityBrowserEventSubscriptions entityId={entityId} /> : null
}

function EntityBrowserEventSubscriptions({ entityId }: { entityId: string }): null {
  const events = HierarchyBrowserEvents.for({ entityId })
  useRefreshQueriesOn(events.capabilitiesChanged, [entityKeys.root])
  useRefreshQueriesOn(events.entityChanged, [entityKeys.root])
  return null
}
